import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ajvirus/Desktop/DTDB_Next/app/offers/Offers.js");
